import { Link } from 'react-router-dom'
import RadioTabs from '../../../components/RadioTabs'
import Search from '../../../components/SearchFilter'
import TableAntd from '../../../components/TableAntd'
import useHook from './hooks'
import style from './style.module.scss'
import Buttonbar from '../../../components/ButtonBar'
export default function ReturnManagement() {
  const {
    currentRadioDict,
    dateSource,
    isTableLoading,
    pagination,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
  } = useHook()

  const listColumn = [
    {
      key: 'typeToName',
      title: '单据类型',
    },
    {
      key: 'orderCode',
      title: '单号',
      render: (text: any, record: any) => {
        if (record.type === 3) {
          return (
            <Link
              to={`/srm/returncancelorder?id=${record.id}&type=returnorder`}
            >
              {text}
            </Link>
          )
        } else {
          return (
            <Link
              to={`/srm/cancelreturnorder?id=${record.id}&type=cancelorder`}
            >
              {text}
            </Link>
          )
        }
      },
    },
    {
      key: 'code',
      title: '采购订单号',
    },
    {
      key: 'receiveMan',
      title: '采购员',
    },
    {
      key: 'groupName',
      title: '采购组织',
    },
    {
      key: 'directShipment',
      title: '是否厂直发',
      render: (text: any) => {
        return <div>{text ? '是' : '否'}</div>
      },
    },
    {
      key: 'orderCreateTime',
      title: '生成时间',
    },
    {
      key: 'orderStateToName',
      title: '状态',
    },
    {
      key: 'num',
      title: '件数',
    },
    {
      key: 'returnPrice',
      title: '金额',
    },
  ]
  return (
    <div>
      <Search
        fieldsData={[
          'supplierOrderReturnCode',
          'supplierOrderReturnGroupName',
          'supplierOrderReturnReceiveMan',
          'supplierOrderReturnStartTime',
          'supplierOrderReturnEndTime',
          'supplierOrderReturnNumber',
          'supplierOrderDirectShipment',
        ]}
        onSearch={handleSearchClick}
        keyName="SUPPLIERORDERRETURN"
        ScreenKey="SUPPLIERORDERRETURN"
      />
      <div className={style['inner-content']}>
        <div className={style['tab-container']}>
          <RadioTabs
            defaultKey={'退货单'}
            radioItemDict={currentRadioDict}
            onChange={handleCheckedChange}
          ></RadioTabs>
        </div>
        <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        <TableAntd
          dataSource={dateSource}
          listColumn={listColumn}
          loading={isTableLoading}
          Y={340}
          pagination={{
            ...pagination,
            onChange: handlePaginationChange,
          }}
          showSize
        ></TableAntd>
      </div>
    </div>
  )
}
import { Link } from 'react-router-dom'
import RadioTabs from '../../../components/RadioTabs'
import Search from '../../../components/SearchFilter'
import TableAntd from '../../../components/TableAntd'
import useHook from './hooks'
import style from './style.module.scss'
import Buttonbar from '../../../components/ButtonBar'
export default function ReturnManagement() {
  const {
    currentRadioDict,
    dateSource,
    isTableLoading,
    pagination,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
  } = useHook()

  const listColumn = [
    {
      key: 'typeToName',
      title: '单据类型',
    },
    {
      key: 'orderCode',
      title: '单号',
      render: (text: any, record: any) => {
        if (record.type === 3) {
          return (
            <Link
              to={`/srm/returncancelorder?id=${record.id}&type=returnorder`}
            >
              {text}
            </Link>
          )
        } else {
          return (
            <Link
              to={`/srm/cancelreturnorder?id=${record.id}&type=cancelorder`}
            >
              {text}
            </Link>
          )
        }
      },
    },
    {
      key: 'code',
      title: '采购订单号',
    },
    {
      key: 'receiveMan',
      title: '采购员',
    },
    {
      key: 'groupName',
      title: '采购组织',
    },
    {
      key: 'directShipment',
      title: '是否厂直发',
      render: (text: any) => {
        return <div>{text ? '是' : '否'}</div>
      },
    },
    {
      key: 'orderCreateTime',
      title: '生成时间',
    },
    {
      key: 'orderStateToName',
      title: '状态',
    },
    {
      key: 'num',
      title: '件数',
    },
    {
      key: 'returnPrice',
      title: '金额',
    },
  ]
  return (
    <div>
      <Search
        fieldsData={[
          'supplierOrderReturnCode',
          'supplierOrderReturnGroupName',
          'supplierOrderReturnReceiveMan',
          'supplierOrderReturnStartTime',
          'supplierOrderReturnEndTime',
          'supplierOrderReturnNumber',
          'supplierOrderDirectShipment',
        ]}
        onSearch={handleSearchClick}
        keyName="SUPPLIERORDERRETURN"
        ScreenKey="SUPPLIERORDERRETURN"
      />
      <div className={style['inner-content']}>
        <div className={style['tab-container']}>
          <RadioTabs
            defaultKey={'退货单'}
            radioItemDict={currentRadioDict}
            onChange={handleCheckedChange}
          ></RadioTabs>
        </div>
        <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        <TableAntd
          dataSource={dateSource}
          listColumn={listColumn}
          loading={isTableLoading}
          Y={340}
          pagination={{
            ...pagination,
            onChange: handlePaginationChange,
          }}
          showSize
        ></TableAntd>
      </div>
    </div>
  )
}
